import { render, staticRenderFns } from "./TagInput.vue.js?vue&type=template&id=d89a95f0!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TagInput.vue?vue&type=template&id=d89a95f0"
import script from "./TagInput.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TagInput.vue?vue&type=script&lang=js"
export * from "./TagInput.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TagInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports